import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { APIConsentService } from '../../_services/consent/API-consent';

@Component({
	selector: 'consentacqqr',
	templateUrl: './consentacqqr.component.html',
	styleUrls: ['./consentacqqr.component.css']
})
export class ConsentAcqQrComponent implements OnInit {

	acquisitionForm: any;
	cs_content: any;
	PEName: any;
	CSTemplateID: any;
	EntityID: any;
	isSubmitted: boolean = false;
	cstemplate_id: number;

	constructor(private fb: FormBuilder,
		private $modal: $ModalManagerService,
		private db: $DBManagerService,
		private route: ActivatedRoute,
		private modalService: BsModalService,
		private cst: APIConsentService,
		private router: Router) {
		
	}
	get f() { return this.acquisitionForm.controls; }


	ngOnInit() {
		this.acquisitionForm = this.fb.group({
			pe_name: ['',],
			cstemplate_id: ['',],
			mobile_number: ['',[Validators.required, Validators.pattern("[6-9]{1}[0-9]{9}")]]
		});

			this.route.queryParams.subscribe((queryParam) => {
		
				console.log("-----params-------",queryParam)
				this.CSTemplateID = queryParam.constempid
				this.EntityID=""
			});

			//this.acquisitionForm.controls['cstemplate_id'].setValue(1608100000000000780);
		//

		this.processQRCode()
	}

	processQRCode() {

		//var data = {
			//constempid: this.acquisitionForm.get('cstemplate_id').value
			// //peid: cstemplate.peid,
			// pename: result.E_Org_Name,
			// tcont: cstemplate.tcont
		var	constempid = this.CSTemplateID
		//}
		console.log("Invoking Process QR Code",constempid)
		this.cst.processQRCd(constempid)
			.subscribe(r => {
				console.log("$$$$$$$$$$$$$$$$$r$$$$$",r)
				if (r.status == "success") {
					console.log("_--------------r-----------------",r,r.message)
					this.cs_content = r.message.tcont;
					this.PEName = r.message.pename;
					console.log("_--------------r-----------------",r.message.peid,r.message.pename)
					this.EntityID= r.message.peid;
					// this.$modal.successModal({
					// 	title: 'Consent Acquisition',
					// 	msg: 'Verified successfully'
					// });
				}
				else {
					//alert(" Only upon Successful verification, the request can be submitted");
					//this.cs_content = "";
					this.$modal.errorModal({
						title: 'Consent Acquisition',
						msg: r.message
					});

				}
			})
	}


	//for Form submition
	onSubmit() {

		var data = {
			msisdn: this.acquisitionForm.get("mobile_number").value,
			//constempid: this.acquisitionForm.get("cstemplate_id").value,
			constempid: this.CSTemplateID,					
			peid: this.EntityID,
			source: "9"
		}

		this.cst.submitconsentforqrcd(data)
			.subscribe(r => {
				console.log("---------------", r.status)
				if (r.status == "200") {
					this.$modal.successModal({
						title: ' Consent Acquisition ',
						msg: 'Thank you for providing your Consent. Consent Acquisition processed successfully'
					})
					this.isSubmitted = true;
				}
				else {

					this.$modal.errorModal({
						title: 'Consent Acquisition',
						msg: r.message
					})
				}

			})
	}

	close(){
		window.close();
	}

}